/** Get Summary Dashboard data */
export const SUB_GROUP_API_SUCCESS = "SUB_GROUP_API_SUCCESS";
export const SUB_GROUP_API_FAIL = "SUB_GROUP_API_FAIL";
export const GET_SUB_GROUP_DATA = "GET_SUB_GROUP_DATA";
